module.exports = __webpack_public_path__ + "img/InternetCertificate.08ae08c7.jpg";